import { ArrowLeftOutlined, FileOutlined } from '@ant-design/icons';
import { Flex, Modal } from 'antd';
import { Button, Space, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../store';
import { setterSharingDocument } from '../store/sharing-document-slice';
import { ViewerAppryze } from '@smx-ui-inspector/viewer-appryze';
import { useToolBarDefault } from '@smx-ui-common/viewer-appryze-tool/use-tool-bar-default';

const DocumentMarkupModal = () => {
    const dispatch = useDispatch<AppDispatch>();
    const openDocument = useSelector((state: RootState) => state.sharingDocument.openDocument);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
         (async () => {
             setIsOpen(!!openDocument);
         })();
    }, [openDocument]);

    /**
     * Handles the action when the close event is triggered.
     */
    const handleOnClose = () => {
        dispatch(setterSharingDocument({ openDocument: null }));
        close();
    };

    /**
     * Close the modal
     */
    const close = () => {
        setIsOpen(false);
    };

    const { getToolBarDefault } = useToolBarDefault();

    const title = (
        <Flex style={{ position: 'relative' }}>
            <Space style={{ width: '100%', justifyContent: 'space-between', paddingBottom: 15 }}>
                <Space align="center">
                    <Button type="primary" icon={<ArrowLeftOutlined />} onClick={close} style={{ marginRight: 10 }} />
                    View document
                    <Tag icon={<FileOutlined />} color="blue">
                        {openDocument?.name}
                    </Tag>
                </Space>
            </Space>
        </Flex>
    );

    return (
        <Modal
            title={title}
            open={isOpen}
            onCancel={handleOnClose}
            closable={false}
            footer={null}
            style={{ padding: 0 }}
            width="100%"
            centered
        >
            <ViewerAppryze
                fileName={openDocument?.name}
                toolBar={getToolBarDefault}
                file={openDocument?.url || null}
                sheetData={{ documentId: openDocument?.id }}
                height={'calc(100vh - 130px)'}
                context={'document'}
                allowedAnnotation={false}
            />
        </Modal>
    );
};

export default DocumentMarkupModal;
